import React from 'react';
import { CtaButton } from './CtaButton';
import { BravePath } from './decor/BravePath';
export function FinalClose() {
  return <section className="bg-ink py-14 text-cream lg:py-24" data-id="element-55" data-mp="s2cagt64fukg">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-56" data-mp="n3iyx6aeadmx">
        <h2 className="font-display text-[36px] leading-tight sm:text-[52px]" data-id="element-57" data-mp="n658fbguj37s">The Next Worried Moment Will Come.</h2>
        <p className="mt-5 text-[18px] leading-relaxed text-cream/80" data-id="element-58" data-mp="1fsq60tnx0bjs">You don’t need to have every answer.</p>
        <p className="mt-2 text-[18px] leading-relaxed text-cream/80" data-id="element-59" data-mp="1atwqkvp2iagz">
          You just need to know what to say, what to do, and what next brave step to take.
        </p>

        <div className="mt-10 flex items-center justify-center gap-4 sm:gap-6" data-id="element-60" data-mp="160k7f135qvvm">
          <span className="font-display text-[26px] tracking-[0.08em] text-dusty sm:text-[36px]" data-id="element-61" data-mp="113k1qra7zv51">WORRY</span>
          <BravePath className="h-8 w-24 sm:h-10 sm:w-36" data-id="element-62" data-mp="1ylan7du94s7r" />
          <span className="font-display text-[26px] tracking-[0.08em] text-gold sm:text-[36px]" data-id="element-63" data-mp="1trg3wbik6f97">BRAVE</span>
        </div>
        <p className="mt-6 font-display text-[26px] italic leading-tight text-sage sm:text-[32px]" data-id="element-64" data-mp="npua36blgsxb">
          Know What to Say. Know What to Do.
        </p>

        <CtaButton to="offer" tone="gold" className="mt-9 w-full sm:w-auto" data-id="element-65" data-mp="e00yi5bgcdt2">
          Get Instant Access Now
        </CtaButton>

        <p className="mt-10 font-display text-[24px] italic text-cream sm:text-[30px]" data-id="element-66" data-mp="ix182q7ifyox">Help them take the next brave step.</p>
      </div>
    </section>;
}